import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_dialog, {
      title: `${_ctx.noticeItem.theme ? '编辑' : '新增'}通知`,
      modelValue: _ctx.selfVisible,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selfVisible) = $event)),
      "close-on-press-escape": false,
      "close-on-click-modal": false,
      center: "",
      top: "5vh",
      onClose: _ctx.handleClose
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_el_button, {
            size: "default",
            onClick: _ctx.handleClose
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 取 消 ")
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "primary",
            size: "default",
            onClick: _ctx.handleSave
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 确 定 ")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          inline: false,
          "label-width": "130px",
          rules: _ctx.rules,
          model: _ctx.formData,
          ref: "ruleForm",
          size: "default"
        }, {
          default: _withCtx(() => [
            _withDirectives(_createVNode(_component_el_form_item, {
              label: "通知编号",
              prop: "noticeCode"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.noticeCode,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.noticeCode) = $event)),
                  modelModifiers: { trim: true },
                  maxlength: "20",
                  disabled: true
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 512), [
              [_vShow, _ctx.formData.noticeCode]
            ]),
            _createVNode(_component_el_form_item, {
              label: "更新系统：",
              prop: "updateSystem"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.formData.updateSystem,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.updateSystem) = $event)),
                  multiple: "",
                  filterable: "",
                  remote: "",
                  placeholder: "请选择需更新系统",
                  onFocus: _ctx.handleDictValues,
                  style: {"width":"100%"},
                  onChange: _ctx.selectOnlineChange,
                  onRemoveTag: _ctx.handleOnlineChangeRemove,
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dictValues, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.value,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onFocus", "onChange", "onRemoveTag"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "同步停服系统：",
              prop: "noticeSystem"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.formData.noticeSystem,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.noticeSystem) = $event)),
                  multiple: "",
                  filterable: "",
                  remote: "",
                  placeholder: "请选择同步停服系统",
                  onFocus: _ctx.handleDictValues,
                  onRemoveTag: _ctx.handleNoticeSystemRemove,
                  clearable: "",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dictValues, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.value,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onFocus", "onRemoveTag"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "通知开始时间：",
              prop: "publishTime"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  type: "datetime",
                  format: "YYYY-MM-DD HH:mm:ss",
                  placeholder: "请选择时间",
                  modelValue: _ctx.formData.publishTime,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.publishTime) = $event)),
                  "disabled-date": _ctx.disabledDate,
                  style: {"width":"100%"}
                }, null, 8, ["modelValue", "disabled-date"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "通知结束时间：",
              prop: "publishEndTime"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  type: "datetime",
                  format: "YYYY-MM-DD HH:mm:ss",
                  placeholder: "请选择时间",
                  modelValue: _ctx.formData.publishEndTime,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.publishEndTime) = $event)),
                  "disabled-date": _ctx.disabledDate,
                  style: {"width":"100%"}
                }, null, 8, ["modelValue", "disabled-date"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "通知栏：",
              prop: "theme"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  maxlength: "50",
                  modelValue: _ctx.formData.theme,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.theme) = $event)),
                  placeholder: "请输入通知栏，限50字符",
                  "show-word-limit": "",
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "具体内容：",
              prop: "content"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "textarea",
                  maxlength: "500",
                  autosize: { minRows: 3, maxRows: 4 },
                  placeholder: "请输入具体通知内容",
                  "show-word-limit": "",
                  modelValue: _ctx.formData.content,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.content) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["rules", "model"])
      ]),
      _: 1
    }, 8, ["title", "modelValue", "onClose"])
  ]))
}